import { Component, Host, Prop, h } from '@stencil/core';
import { getIcon } from '../../assets/svg/svg';

@Component({
  tag: 'cms-icon',
  styleUrl: 'cms-icon.scss',
  shadow: true,
})
export class CmsIcon {
  /**
   * set the icon like plus or minus, all icons find in src\assets\svg\svg.tsx
   */
  @Prop({ reflect: true }) icon: string | undefined;

  /**
   * set the icon size like sm=20px md=24px xl=32px
   */
  @Prop({ reflect: true }) size = 'sm';

  /**
   * set the icon color like --cms-semanticColors-primary-icon
   */
  @Prop({ reflect: true }) colorToken: string;

  /**
   * overwrite the icons default viewBox
   */
  @Prop({ reflect: true }) viewBox?: string;

  /**
   * set the title for the icon
   */
  @Prop({ reflect: true }) iconTitle?: string;

  /**
   * set the icon display like block inline-block none or disabled
   */
  @Prop() display = 'inline-block';

  render() {
    return (
      <Host style={{ display: this.display }}>
        <div
          class={`wrapper ${this.size}`}
          style={
            this.colorToken !== undefined
              ? { '--cms-theme-svg-color': `var(${this.colorToken})` }
              : {}
          }
          innerHTML={
            this.icon !== undefined
              ? getIcon(this.icon, this.size, this.iconTitle, this.viewBox)
              : null
          }
        />
      </Host>
    );
  }
}
